module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/vMzlOW/images/e9781439616864_cover.jpg?1684514529003",
      "alt": "This image is the cover for the book Grand Rapids, Postcard History"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Grand Rapids, Postcard History\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In the years between 1890 and 1950, the city of Grand Rapids grew from a small Midwestern town of great potential into a large and important commercial and manufacturing center. With the growth of the city and its population came a large variety of activities, commercial and recreational, which were happily recorded in a huge array of postcards produced by both local and national printers. These cards and the moments they preserve provide a unique glimpse into the life and growth of Grand Rapids.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Thomas R. Dilley\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Thomas R. Dilley is a lifelong resident of Grand Rapids, where he lives with his wife, Debra, daughter, Sarah, and basset hound, Ruthie. His 40-year interest in the history of his hometown is refl ected in his avid collection of the postcards in Grand Rapids: Community and Industry, as well as a large assortment of other materials documenting the history of the city. He is a trustee of the Grand Rapids Historical Society and is the author of Grand Rapids in Vintage Postcards: 1890-1940.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Arcadia Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0